import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const AlertIcon = (props) => {
  return (
    <svg
     
      height="24"
      viewBox="0 0 512 512"
      width="24"
      className="svgNew" 
      onClick={props.onClick}
      style={{display:"block"}}
    >
     
     
    <g id="_x38__x2C__Google_Alerts"><g>
      <path d="M443.5,151c11.051,0,20,8.95,20,20s-8.949,20-20,20c-11.039,0-20-8.95-20-20S432.461,151,443.5,151    z" 
      />
      <circle cx="78.5" cy="121" r="30" />
      <path d="M288.08,426c1.881,4.63,2.92,9.69,2.92,15c0,22.09-17.91,40-40,40s-40-17.91-40-40    c0-5.31,1.04-10.37,2.92-15H251H288.08z" />
      <circle cx="251" cy="61" r="30" /><circle cx="441" cy="233.5" r="7.5" />
      <circle cx="421" cy="328.5" r="7.5" />
      <circle cx="366" cy="83.5" r="7.5" /><circle cx="131" cy="53.5" r="7.5" />
      <circle cx="86" cy="323.5" r="7.5" />
      <circle cx="51" cy="208.5" r="7.5" />
      <path d="M251,96c-19.299,0-35-15.701-35-35s15.701-35,35-35s35,15.701,35,35S270.299,96,251,96z M251,36    c-13.785,0-25,11.215-25,25s11.215,25,25,25s25-11.215,25-25S264.785,36,251,36z" />
      <path d="M251,486c-24.813,0-45-20.187-45-45c0-5.83,1.106-11.51,3.288-16.882    c1.039-2.558,3.953-3.791,6.514-2.751c2.559,1.039,3.79,3.956,2.751,6.515C216.859,432.053,216,436.466,216,441    c0,19.299,15.701,35,35,35s35-15.701,35-35c0-4.534-0.859-8.948-2.553-13.118c-1.039-2.559,0.193-5.476,2.752-6.515    c2.559-1.038,5.475,0.194,6.514,2.751C294.895,429.489,296,435.169,296,441C296,465.813,275.813,486,251,486z" />
      <path d="M251,431c-2.761,0-5-2.238-5-5V91c0-2.761,2.239-5,5-5s5,2.239,5,5v335    C256,428.762,253.761,431,251,431z" />
      <path d="M78.5,156c-19.299,0-35-15.701-35-35s15.701-35,35-35s35,15.701,35,35S97.799,156,78.5,156z     M78.5,96c-13.785,0-25,11.215-25,25s11.215,25,25,25s25-11.215,25-25S92.285,96,78.5,96z" />
      <path d="M443.5,196c-13.785,0-25-11.215-25-25s11.215-25,25-25s25,11.215,25,25S457.285,196,443.5,196z     M443.5,156c-8.271,0-15,6.729-15,15s6.729,15,15,15s15-6.729,15-15S451.771,156,443.5,156z" />
      <path d="M373.5,376V213.5C373.5,145.854,318.662,91,251,91c-67.65,0-122.5,54.85-122.5,122.5V376l-45,50    c66.095,0,259.296,0,335,0L373.5,376z" />
      <polygon points="251,376 251,426 213.92,426 83.5,426 128.5,376   " />
      <path d="M251,91v285H128.5V213.5C128.5,145.85,183.35,91,251,91z" />
      <path d="M421.968,422.379L378.5,374.082V213.5c0-34.056-13.263-66.074-37.344-90.156    C317.074,99.263,285.056,86,251,86c-70.304,0-127.5,57.196-127.5,127.5v160.582l-43.716,48.573    c-1.321,1.468-1.654,3.575-0.851,5.379S81.525,431,83.5,431h335c0.007,0,0.012-0.001,0.02,0c2.762,0,5-2.238,5-5    C423.52,424.575,422.924,423.29,421.968,422.379z M133.5,371V213.5C133.5,148.71,186.21,96,251,96    c31.385,0,60.892,12.222,83.084,34.416c22.193,22.193,34.416,51.7,34.416,83.084V371 M371.273,381l36,40H94.727l36-40" />
    </g>
    </g>
    <g id="Layer_1"/>

    </svg>
  );
};

export default AlertIcon;
